import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { User } from '@/api/types'

export const meKeys = { me: ['me'] as const }

export const meQuery = () =>
  queryOptions({ queryKey: meKeys.me, queryFn: ({ signal }) => api.get<User>('/me', { signal }) })

export function useMe() {
  return useQuery(meQuery())
}
